(() => {
  const cartRoot = document.querySelector('cart-items');
  if (!cartRoot) return;

  const savedScrollPosition = window.sessionStorage.getItem('collectport-cart-scroll');
  if (savedScrollPosition !== null) {
    window.sessionStorage.removeItem('collectport-cart-scroll');
    window.requestAnimationFrame(() => window.scrollTo(0, Number(savedScrollPosition) || 0));
  }

  let updatePending = false;

  async function updateCart(line, quantity) {
    if (updatePending) return;
    updatePending = true;
    cartRoot.classList.add('cp-cart-is-updating');

    try {
      const cartChangeUrl =
        typeof routes !== 'undefined' && routes.cart_change_url ? routes.cart_change_url : '/cart/change.js';
      const response = await fetch(cartChangeUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: Number(line),
          quantity: Number(quantity),
        }),
      });
      const result = await response.json();

      if (!response.ok || result.errors) {
        throw new Error(result.description || result.message || result.errors || 'Warenkorb konnte nicht aktualisiert werden.');
      }

      window.sessionStorage.setItem('collectport-cart-scroll', String(window.scrollY));
      window.location.reload();
    } catch (error) {
      updatePending = false;
      cartRoot.classList.remove('cp-cart-is-updating');
      const errorElement = document.getElementById('cart-errors');
      if (errorElement) {
        errorElement.textContent = error.message || 'Warenkorb konnte nicht aktualisiert werden.';
      }
    }
  }

  async function clearCart(button) {
    if (updatePending) return;
    updatePending = true;
    cartRoot.classList.add('cp-cart-is-updating');
    if (button) {
      button.disabled = true;
      button.textContent = 'Wird geleert...';
    }

    try {
      const cartClearUrl =
        typeof routes !== 'undefined' && routes.cart_clear_url ? routes.cart_clear_url : '/cart/clear.js';
      const response = await fetch(cartClearUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      const result = await response.json();

      if (!response.ok || result.errors) {
        throw new Error(result.description || result.message || result.errors || 'Warenkorb konnte nicht geleert werden.');
      }

      window.sessionStorage.setItem('collectport-cart-scroll', '0');
      window.location.reload();
    } catch (error) {
      updatePending = false;
      cartRoot.classList.remove('cp-cart-is-updating');
      if (button) {
        button.disabled = false;
        button.textContent = 'Warenkorb leeren';
      }
      const errorElement = document.getElementById('cart-errors');
      if (errorElement) {
        errorElement.textContent = error.message || 'Warenkorb konnte nicht geleert werden.';
      }
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const removeLink = event.target.closest('cart-remove-button a');
      if (!removeLink || !cartRoot.contains(removeLink)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      const removeButton = removeLink.closest('cart-remove-button');
      updateCart(removeButton?.dataset.index, 0);
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const clearButton = event.target.closest('[data-cp-clear-cart]');
      if (!clearButton || !cartRoot.contains(clearButton)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      clearCart(clearButton);
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target.closest('cart-items input[name="updates[]"]');
      if (!input) return;

      event.stopImmediatePropagation();
      const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
      updateCart(input.dataset.index, quantity);
    },
    true
  );
})();
